export class InvoiceDetailRejectedReasonListPresenter extends Array {
  constructor(result) {
    const mapped = result.map(value => ({
      id: value.id,
      message: value.message,
    }));

    super(...mapped);
  }
}
